import { FunctionComponent } from 'react';
import { useTranslation } from 'next-i18next';

import { config } from '@restworld/utils-common';

import {
  CopyrightContainer,
  Divider,
  FooterColumnGroup,
  FooterColumnItem,
  FooterColumnItemGroup,
  FooterColumnTitle,
  FooterMainGrid,
  LogoAndSocials,
  SmartAndStartLogos,
  SocialIcons,
} from './footer.components';

interface FooterProps {
  copyrightOnly?: boolean;
}

export const CopyrightText: FunctionComponent = () => {
  const { t } = useTranslation('common');
  return (
    <>
      © Copyright {new Date().getFullYear()} {t('footer.all_right_reserved_text')}
    </>
  );
};

const CopyrightSection: FunctionComponent = () => {
  return (
    <CopyrightContainer>
      <CopyrightText />
    </CopyrightContainer>
  );
};

export const Footer: FunctionComponent<FooterProps> = ({ copyrightOnly }) => {
  const { t } = useTranslation('common');

  if (copyrightOnly) {
    return (
      <footer className="bg-gray-50 text-black text-lg md:text-base">
        <div className="container mx-auto w-full px-6 py-6 lg:px-20 xl:px-48">
          <CopyrightSection />
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-gray-50 text-black pt-16 text-lg md:text-base">
      <div className="container mx-auto w-full px-6 py-12 lg:px-20 xl:px-48">
        <FooterMainGrid>
          <LogoAndSocials />
          <div className="grid grid-cols-2 gap-12 md:col-span-2 lg:grid-cols-4">
            <FooterColumnGroup>
              <FooterColumnTitle>{t('footer.for_talents')}</FooterColumnTitle>
              <FooterColumnItemGroup>
                <FooterColumnItem href="/cerco-lavoro">{t('search_for_jobs')}</FooterColumnItem>
                <FooterColumnItem href="/">{t('how_does_it_work')}</FooterColumnItem>
              </FooterColumnItemGroup>
            </FooterColumnGroup>
            <FooterColumnGroup>
              <FooterColumnTitle>{t('for_companies')}</FooterColumnTitle>
              <FooterColumnItemGroup>
                <FooterColumnItem href="https://www.restworld.it/aziende?utm_source=worker-app" newWindow>
                  {t('footer.hire_staff')}
                </FooterColumnItem>
                <FooterColumnItem href="/getting-started?utm_source=worker-app">
                  {t('footer.post_your_venue')}
                </FooterColumnItem>
                <FooterColumnItem href="/">{t('how_does_it_work')}</FooterColumnItem>
              </FooterColumnItemGroup>
            </FooterColumnGroup>
            <FooterColumnGroup>
              <FooterColumnTitle>{t('footer.agency')}</FooterColumnTitle>
              <FooterColumnItemGroup>
                <FooterColumnItem href="/chi-siamo">{t('who_we_are')}</FooterColumnItem>
                <FooterColumnItem href="/lavora-con-noi">{t('work_with_us')}</FooterColumnItem>
                <FooterColumnItem href="https://restworld.it/collaborazioni/referral">
                  {t('footer.referral_program')}
                </FooterColumnItem>
              </FooterColumnItemGroup>
            </FooterColumnGroup>
            <FooterColumnGroup>
              <FooterColumnTitle>{t('footer.resources')}</FooterColumnTitle>
              <FooterColumnItemGroup>
                <FooterColumnItem href="https://www.restworld.it/assistenza" newWindow>
                  FAQ
                </FooterColumnItem>
                <FooterColumnItem href="/contatti">{t('contact_us')}</FooterColumnItem>
                <FooterColumnItem href={config.restworldPrivacyUrl}>Privacy policy</FooterColumnItem>
                <FooterColumnItem href={config.restworldCookiePolicyUrl}>Cookie policy</FooterColumnItem>
              </FooterColumnItemGroup>
            </FooterColumnGroup>
          </div>
        </FooterMainGrid>
        <SmartAndStartLogos />
        <Divider />
        <CopyrightSection />
      </div>
    </footer>
  );
};
export { SocialIcons };
